import { Mp4Box } from "./Mp4Box.class";

export class edts extends Mp4Box {}
